import { render, staticRenderFns } from "./dataReport.vue?vue&type=template&id=ce1437d6&scoped=true"
import script from "./dataReport.vue?vue&type=script&lang=js"
export * from "./dataReport.vue?vue&type=script&lang=js"
import style0 from "./dataReport.vue?vue&type=style&index=0&id=ce1437d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1437d6",
  null
  
)

component.options.__file = "dataReport.vue"
export default component.exports